import { render, staticRenderFns } from "./totalEnterprises.vue?vue&type=template&id=7f9bbdc8&"
import script from "./totalEnterprises.vue?vue&type=script&lang=js&"
export * from "./totalEnterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports